import {PROJECT_SELECTED} from "../../../reducers/indexReducer";


export const getProjectSettingsSuccess = (project) =>{
    return {
        type: PROJECT_SELECTED,
        payload: {project}
    }
}